import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import detailKrona from '@/components/detail_krona'
import detailDist from '@/components/detail_dist'
import detailQiime from '@/components/detail_qiime'
import error from '@/components/405'
import setting from '@/components/setting'
import brief from '@/components/brief'
import license from '@/components/license'
import downloadInstall from '@/components/downloadInstall'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: 'KSSD Home',
        keepAlive: true
      }
    },
    {
      path: '/detail_krona',
      name: 'detail_krona',
      component: detailKrona,
      meta: {
        title: 'KSSD detail_krona',
        keepAlive: true
      }
    },
    {
      path: '/detail_dist',
      name: 'detail_dist',
      component: detailDist,
      meta: {
        title: 'KSSD detail_distance',
        keepAlive: true
      }
    },
    {
      path: '/detail_qiime',
      name: 'detail_qiime',
      component: detailQiime,
      meta: {
        title: 'KSSD detail_Qiime',
        keepAlive: true
      }
    },
    {
      path: '/405',
      name: 'error',
      component: error,
      meta: {
        title: 'KSSD 405',
        keepAlive: true
      }
    },
    {
      path: '/setting',
      name: 'setting',
      component: setting,
      meta: {
        title: 'KSSD setting',
        keepAlive: true
      }
    },
    {
      path: '/brief',
      name: 'brief',
      component: brief,
      meta: {
        title: 'KSSD brief',
        keepAlive: true
      }
    },
    {
      path: '/license',
      name: 'license',
      component: license,
      meta: {
        title: 'KSSD license',
        keepAlive: true
      }
    },
    {
      path: '/downloadInstall',
      name: 'downloadInstall',
      component: downloadInstall,
      meta: {
        title: 'KSSD download install',
        keepAlive: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js